import React from "react";
import PropTypes from "prop-types";
import Color from "color";
import { css } from "glamor";

import styles from "./styles.module.scss";

const Bar = (props) => {
  const barRule = css({
    justifyContent: props.justifyContent
  });

  const barFillRule = css({
    backgroundColor: Color(props.brandColor),
    width: `${props.value}%`
  });

  return (
    <div className={`${styles.bar} ${barRule}`}>
      <div className={`${styles.barFill} ${barFillRule}`} />
    </div>
  );
};

Bar.propTypes = {
  brandColor: PropTypes.string,
  justifyContent: PropTypes.oneOf(["start", "end"]),
  value: PropTypes.number
};

Bar.defaultProps = {
  brandColor: "#0000FF",
  justifyContent: "end",
  value: 30
};

export default Bar;
